export default {
	nome: null,
	cliente: null,
	email: null,
	login: null,
	produto: null,
	contrato: null,
	perfil: null,
	token: null,
	avisos: 0,
	autenticado: false,
	contratosPerfil: null,
	clientes: null,
	produtos: null,
	todosContratosPerfil: null,
	idClienteSelecionado: null,
	telefone: null,
	aceiteTermoUso: null,
	respondeuPesquisa: null,
	respondeuPesquisaProcon: null,
	naoLembrarPesquisa: null,
	publicacoesNaoLidas: 0,
	processosNaoLidos: 0,
	formularioAtivo: false,
	dataTermoAceito: null,
	horarioNotificacao8h: null,
	horarioNotificacao12h: null,
	horarioNotificacao17h: null,
	moduloProdutos: null,
	moduloProdutos_Cadastro: null,
	moduloProdutos_Consulta: null,
	moduloFinanceiro: null,
	moduloMensagens: null,
	moduloGerenciamentoAcesso: null,
	moduloAtendimento: null,
	moduloAtendimento_Cadastro: null,
	moduloAtendimento_Outros: null,
	usaMFA: null,
	mostrarPesquisa: true,
	listaVideosModal: null
};
